/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback, errorCallback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        // Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      console.error(XMLHttpRequest, textStatus);
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

/* Quickview add-to-cart state helpers */
Shopify.quickviewSetLoading = function($button, isLoading) {
  $button.prop('disabled', isLoading).toggleClass('is-loading', isLoading);
  if (isLoading) {
    $button.attr('aria-busy', 'true');
  } else {
    $button.removeAttr('aria-busy');
  }
};

Shopify.quickviewShowStatus = function(form_id, message, isError) {
  jQuery('#' + form_id).find('.quickview-status')
    .toggleClass('is-error', !!isError)
    .text(message)
    .prop('hidden', false);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback, errorCallback) {
    var isQuickview = form_id == "add-item-qv";
    var $qvButton = jQuery('#' + form_id).find(".addtocartqv");
    if (isQuickview) {
      if ($qvButton.prop('disabled')) {
        return;
      }
      jQuery('#' + form_id).find('.quickview-status').prop('hidden', true).removeClass('is-error').empty();
      Shopify.quickviewSetLoading($qvButton, true);
    }
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      // beforeSend: function(){
      //   if(form_id == "add-item-qv") {
      //     jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      //   }
      // },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if (isQuickview) {
            Shopify.quickviewSetLoading($qvButton, false);
            $qvButton.blur();
            jQuery('#quickViewModal').modal('hide');
          }
          // if(form_id != "add-item-qv") {
          //   Shopify.cartPopapForm(variant_id);
          // } else {
          // 	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
          //   jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
          //   setTimeout(function(){
          //     	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
          //   	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          //   }, 2000);
          // }
          Shopify.onItemAdded(line_item);
        }

      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          if ((typeof errorCallback) === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            Shopify.onError(XMLHttpRequest, textStatus);
          }
        } else {
          var qvMessage = '';
          try {
            var qvData = XMLHttpRequest.responseJSON || JSON.parse(XMLHttpRequest.responseText);
            qvMessage = qvData.description || '';
          } catch (e) {}
          Shopify.quickviewSetLoading($qvButton, false);
          Shopify.quickviewShowStatus(form_id, qvMessage || jQuery(".quickViewModal_info .button_error").text(), XMLHttpRequest.status != 422);
          // A 422 can be a partial add (only the available quantity was added).
          // Refresh from the authoritative cart state; harmless if nothing was added.
          if (XMLHttpRequest.status == 422) {
            jQuery.getJSON('/cart.js', function(cart) {
              Shopify.onCartUpdate(cart);
            });
          }
        }
      }
    };
    jQuery.ajax(params);
    
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id, callback, errorCallback) {
  Shopify.addItemFromForm(form, product_id, callback, errorCallback);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').text(''+title+'');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').text(''+title+'');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  
var currentCurrency = getActiveCurrency(); // use the cart_currency cookie
  console.log("✅ Active currency:", currentCurrency);

  const currencyFormats = {
    USD: { symbol: '$', position: 'before' },
    EUR: { symbol: '€', position: 'after' },
    GBP: { symbol: '£', position: 'before' },
    CHF: { symbol: 'CHF ', position: 'before' },
    AUD: { symbol: '$', position: 'before' },
    NZD: { symbol: '$', position: 'before' },
  };

  const formatFor = currencyFormats[currentCurrency] || { symbol: currentCurrency, position: 'before' };

  const formatMoney = formatFor.position === 'before'
  ? `<span class='money'>${formatFor.symbol}{{amount}}</span>`
  : `<span class='money'>{{amount}} ${formatFor.symbol}</span>`;

  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

  
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length == 1) {
            jQuery(".single-product-cart, .item-single-item-count").css({"display": "block"});
            jQuery(".cart-empty-title, .item-multiple-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="{{ item.img.alt }}" style="width: 90px;"></a><div class="item-close"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="sli sli-close"></i></a></div></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }			
          else if (value.length) {
            jQuery(".single-product-cart, .item-multiple-item-count").css({"display": "block"});
            jQuery(".cart-empty-title,  .item-single-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="{{ item.img.alt }}" style="width: 90px;"></a><div class="item-close"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="sli sli-close"></i></a></div></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".single-product-cart, .item-single-item-count").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};

function getActiveCurrency() {
  const match = document.cookie.match(/(?:^|; )cart_currency=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '{{ shop.currency }}';
}